import React from 'react';

import { MagicWallCard } from '@shared/api/types/magicWall';

import MagicOrderWallOfferCard from './MagicOrderWallOfferCard';

interface MagicOrderWallOffersListProps {
  list: MagicWallCard[];
  showStatus?: boolean;
}

const MagicOrderWallOffersList = ({ list, showStatus }: MagicOrderWallOffersListProps) => (
  <ul className="flex gap-5 flex-col xl:gap-10 xl:grid xl:grid-cols-2">
    {list.map((card) => (
      <li key={card.id} className="[&>*]:h-full" data-qa="magic-board-offer">
        <MagicOrderWallOfferCard card={card} showStatus={showStatus} />
      </li>
    ))}
  </ul>
);

export default MagicOrderWallOffersList;
